import {Space, Label} from '@mc/ui-v4';
import React from 'react';
import {useForm, useFormState} from 'react-final-form';
import './ColorPicker.scss';
import classNames from 'classnames';
import {get} from 'lodash-es';

type Props = {
    name: string;
    items: string[];
    disabled: boolean;
    required?: boolean;
    label?: string;
};

export const COLOR_ITEMS = [
    'FFFFFF',
    'FF9E2B',
    'FDC911',
    'FF553E',
    'AFD442',
    '32CD82',
    '1941D2',
    'A4B1DF',
    'E852EB',
    'F10E96',
    'EE94CE',
    '98119B',
    '888488',
    '373737',
];

export const ColorPicker: React.FC<Props> = ({items, name, disabled, label, required}) => {
    const {change} = useForm();
    const {values, touched, errors} = useFormState();

    const changeValue = (newValue?: string) => {
        if (!disabled) {
            change(name, newValue === 'null' ? null : newValue);
        }
    };

    const handleKeyDown = (event: React.KeyboardEvent, color: string) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            changeValue(color);
        }
    };

    return (
        <>
            {label && (
                <Label>
                    {label}
                    {required && <span className={'manual-required'}>*</span>}
                </Label>
            )}
            <Space className={'color-picker py-1'} wrap>
                {items.map(color => (
                    <button
                        key={color}
                        onClick={() => changeValue(color)}
                        onKeyDown={e => handleKeyDown(e, color)}
                        title={color === 'null' ? 'Žádná barva' : `#${color}`}
                        className={classNames('color-bubble', {
                            ['disabled']: disabled,
                            ['active']: get(values, name)?.toUpperCase().replace('#', '') === color || (color === 'null' && get(values, name) === null),
                        })}
                        style={{backgroundColor: `#${color}`}}
                        disabled={disabled}
                        type="button"
                        aria-pressed={get(values, name)?.toUpperCase().replace('#', '') === color}
                    />
                ))}
            </Space>
            {required && touched[name] && errors[name] && <>{errors[name]}</>}
        </>
    );
};
